import styled from 'styled-components';
import { Title, Text } from '@/shared/ui';
import { BorisScreener } from '@/shared/borisScreenerTheme';

/**
 * Boris result/terminal-screen typography (register.css `.rg-result-h` /
 * `.rg-result-p`), applied to the app's own result screens (not-eligible,
 * eligibility states). Visual only — wraps the existing `Title`/`Text` so
 * their content and `size`/`centered` props pass straight through; the
 * declared rules here win via styled-components extension precedence.
 */
export const ResultTitle = styled(Title)`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.12;
  letter-spacing: -0.015em;
  color: ${BorisScreener.ink};

  /* Boris .reg-dt scales the result heading up on desktop. */
  @media (min-width: 900px) {
    font-size: 36px;
  }
`;

export const ResultBody = styled(Text)`
  font-size: 17px;
  line-height: 1.5;
  color: ${BorisScreener.inkSoft};
  max-width: 380px;
  white-space: pre-line;
`;
